import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import { OrderAPackageContext } from '../../../OrderAPackageContext';
import { TotalAmount } from './TotalAmount';
import { Savings } from './Savings';

import './totalPricing.scss';

export const TotalPricing = ({
  value,
  totalValue,
  bundleSavings,
  additionalSavings,
  totalSavings,
  title,
  resize,
  basic,
  noTooltip,
  noPadding,
  hideTotalPricing,
  haveAuthMapPolicy
}) => {
  const { state } = useContext(OrderAPackageContext);
  const { totalPricing } = state;

  return (
    <div className="total-price">
      { value &&
        (
          <TotalAmount
            value={totalPricing.value}
            mapExistsInPackage={totalPricing.mapExistsInPackage}
            title={title}
            resize={resize}
            basic={basic}
            noPadding={noPadding}
            noTooltip={noTooltip}
            hideTotalAmount={hideTotalPricing}
            haveAuthMapPolicy={haveAuthMapPolicy}
          />
        )}
      { totalValue &&
        (
          <TotalAmount
            value={totalPricing.totalValue}
            mapExistsInPackage={totalPricing.mapExistsInPackage}
            title={title}
            resize={resize}
            basic={basic}
            noPadding={noPadding}
            noTooltip={noTooltip}
            hideTotalAmount={hideTotalPricing}
            haveAuthMapPolicy={haveAuthMapPolicy}
          />
        )}
      { bundleSavings &&
        totalPricing.hasBundleSavings &&
        (
          <Savings
            value={totalPricing.bundleSavings}
            mapExistsInPackage={totalPricing.mapExistsInPackage}
            title={title}
            label={totalPricing.bundleLabel}
            isBundleSaving
            hideSaving={hideTotalPricing}
          />
        )}
      { additionalSavings &&
        totalPricing.hasAdditionalSavings &&
        (
          <Savings
            value={totalPricing.additionalSavings}
            mapExistsInPackage={totalPricing.mapExistsInPackage}
            title={title}
            label={totalPricing.additionalLabel}
            hideSaving={hideTotalPricing}
          />
        )}
      { totalSavings &&
        totalPricing.hasTotalSavings &&
        (
          <Savings
            value={totalPricing.totalSavings}
            percentage={totalPricing.totalPercentage}
            mapExistsInPackage={totalPricing.mapExistsInPackage}
            title={title}
            isTotalSaving
            hideSaving={hideTotalPricing}
          />
        )}
    </div>
  );
};

TotalPricing.propTypes = {
  value: bool,
  totalValue: bool,
  bundleSavings: bool,
  additionalSavings: bool,
  totalSavings: bool,
  title: string,
  resize: bool,
  basic: bool,
  noPadding: bool,
  noTooltip: bool,
  hideTotalPricing: bool,
  haveAuthMapPolicy: bool
};

TotalPricing.defaultProps = {
  value: false,
  totalValue: false,
  bundleSavings: false,
  additionalSavings: false,
  totalSavings: false,
  title: '',
  resize: false,
  basic: false,
  noPadding: false,
  noTooltip: false,
  hideTotalPricing: false,
  haveAuthMapPolicy: false
};

TotalPricing.displayName = 'TotalPricing';